import { ContentHubType } from 'src/constants';
import { getCourseUrl, getHubUrl, getLessonUrl, getPathUrl, withPrefix } from 'src/utils/getUrl';
import { getSlug } from 'src/utils/slug';

interface BreadCrumbsLink {
  label: string;
  link: string;
}

const LEARNING_PATHS_HUB_LABEL = 'Learning Paths';

export const generateBreadcrumbLinks = (
  learningPath?: { title: string; slug: string },
  course?: { title: string; slug: string },
  lessonSlug?: string,
): BreadCrumbsLink[] => {
  const links: BreadCrumbsLink[] = [];

  const isHub = globalThis.location.pathname.includes(getHubUrl(ContentHubType.LEARNING_PATHS));

  const isCourse = course && globalThis.location.pathname.includes(getCourseUrl(getSlug(course)));
  const isLesson = lessonSlug && globalThis.location.pathname.includes(getLessonUrl({ lessonSlug }));
  const hubUrl = getHubUrl(ContentHubType.LEARNING_PATHS);

  if (isHub) {
    links.push({
      label: LEARNING_PATHS_HUB_LABEL,
      link: hubUrl,
    });
  }

  if (learningPath && (isCourse || isLesson)) {
    const basePath = isHub ? hubUrl : '';

    links.push({
      label: learningPath.title,
      link: withPrefix(getPathUrl(getSlug(learningPath)), basePath),
    });
  }

  if (isLesson && course) {
    const basePath = isHub ? hubUrl : '';

    links.push({
      label: course.title,
      link: withPrefix(getCourseUrl(getSlug(course), getSlug(learningPath)), basePath),
    });
  }

  return links;
};
